const HAV_COOKIE_NAME = 'hav';
const ADL_WHITELIST = [
    'admin1',
    'appname',
    'appversion',
    'bookingid',
    'calendarlastupdated',
    'country',
    'currency',
    'displaylocale',
    'displayprice',
    'exposedtests',
    'features',
    'fullorderrentalrate',
    'gbsessionurl',
    'item2',
    'item3',
    'item4',
    'lbsuuid',
    'listingid',
    'monikerbrand',
    'mpaasregion',
    'multiunit',
    'numadults',
    'numchildren',
    'numinfants',
    'ordertax',
    'ownertype',
    'paymentsplit',
    'pdp',
    'pmid',
    'postalcode',
    'publicuuid',
    'rdd',
    'requestmarker',
    'reservation_id',
    'reservationid',
    'reservationids',
    'responsivenesstime',
    'servicefee',
    'sessionid',
    'sort',
    'testattributes',
    'tripid',
    'visitorid',
    'visitortype',
    'withpets'
];

const DIRECTWORD_URL = 'https://www.directword.io/survey/domain=';
const SURVEY_HEIGHT = 700;
const SURVEY_WIDTH = 640;

class SiteFeedback {
    /**
     *
     * @param {string} name - Name of the cookie, which will be interpolated
     * into regular expression that will be used to query the document.cookie
     * string.
     * @returns {(string|null)} Cookie value by name if exists, otherwise null.
     */
    getCookie = (name) => {
        const cookieRegExp = new RegExp(`${name}=([^;]+)`);
        const value = cookieRegExp.exec(document.cookie);
        return value !== null ? decodeURIComponent(value[1]) : null;
    };

    open = () => {
        let metadata = {};
        const ADL = window.analyticsdatalayer;
        const detector = window._detector;

        if (ADL) {
            ADL_WHITELIST.forEach((key) => {
                if (ADL[key] && ADL[key] !== '-1') {
                    metadata[key] = `${ADL[key]}`;
                }
            });
        }

        if (
            typeof document !== 'undefined' &&
            document.cookie.indexOf(HAV_COOKIE_NAME) !== -1
        ) {
            metadata[HAV_COOKIE_NAME] = `${this.getCookie(HAV_COOKIE_NAME)}`;
        }

        if (typeof window.location.href === 'string') {
            /**
             * Some browsers can limit the max url length to 2,000 characters,
             * since the metadata goes into the query string, we want to avoid
             * exceeding the url max if the referring page url has a giant
             * query string. URL is important data but not worth shoving out
             * all the rest of the metadata.
             */
            const MAX_URL_METADATA_LENGTH = 384;
            const URL_SLICED = window.location.href.slice(
                0,
                MAX_URL_METADATA_LENGTH
            );
            metadata.url = `${URL_SLICED}`;
        }

        // Build the site/locale/adl specific url
        let directWordLink = `${DIRECTWORD_URL}${window.location.hostname}`;
        if (
            ADL &&
            typeof ADL.displaylocale === 'string' &&
            ADL.displaylocale.length > 1
        ) {
            directWordLink = `${directWordLink}/locale=${ADL.displaylocale}`;
        }
        const replayCookieQueryString =
            typeof detector === 'object' &&
            typeof detector.sessionId === 'string'
                ? `&_cls_s=${detector.sessionId}`
                : '';
        const siteFeedbackLinkWithQueryString = `${directWordLink}?metadata=${encodeURIComponent(
            JSON.stringify(metadata)
        )}${replayCookieQueryString}`;

        // Calculate position to center survey in browser window.
        const y = window.outerHeight / 2 + window.screenY - SURVEY_HEIGHT / 2;
        const x = window.outerWidth / 2 + window.screenX - SURVEY_WIDTH / 2;
        const windowFeatures = `
            left=${x},
            height=${SURVEY_HEIGHT},
            resizable=yes,
            screenX=${x},
            screenY=${y},
            scrollbars=yes
            top=${y},
            width=${SURVEY_WIDTH},
        `;
        window.open(siteFeedbackLinkWithQueryString, '_blank', windowFeatures);
    };
}

export default SiteFeedback;
